import { styled as t, Box as i, Typography as d } from "@mui/material";
import { useFrontendConfigContext as I } from "../../config-lib/contexts/FrontendConfigContext.js";
import S from "../../temp-lib/components/share/next/Image.js";
import { useAccountContext as V } from "../../temp-lib/contexts/account/AccountContext.js";
import "../../ui-lib/components/ApeironBattleDemoTitle.js";
import "../../ui-lib/components/ApeironButton.js";
import "../../ui-lib/components/ApeironCheckbox.js";
import "../../ui-lib/components/ApeironCounter.js";
import "../../ui-lib/components/ApeironDivider.js";
import "../../ui-lib/components/ApeironGotoRoundButton.js";
import "../../ui-lib/components/ApeironLoadingNow.js";
import "../../ui-lib/components/ApeironMessagePopup.js";
import "../../ui-lib/components/ApeironNumberTextField.js";
import "../../ui-lib/components/ApeironPleaseWait.js";
import "../../ui-lib/components/ApeironSimpleButton.js";
import "../../ui-lib/components/ApeironTooltip.js";
import "../../ui-lib/components/ApeironTooltipInfoButton.js";
import "../../ui-lib/components/ApeironTooltipSection.js";
import "../../ui-lib/components/BackButton.js";
import "../../ui-lib/components/GotoBattlePassEvent.js";
import "../../ui-lib/components/GotoCheckIn.js";
import "../../ui-lib/components/GotoGiftCode.js";
import "../../ui-lib/components/GotoLootRush.js";
import "../../ui-lib/components/GotoMarketplace.js";
import "../../ui-lib/components/GotoWebStore.js";
import z from "../../ui-lib/components/LoginRequestButton.js";
import "../../ui-lib/components/MuiCheckbox.js";
import "../../ui-lib/components/MuiLoading.js";
import "../../ui-lib/components/Triangle.js";
import { AnimateTime as D } from "../../ui-lib/constants/layout.js";
import "../../ui-lib/constants/media.js";
import "../../temp-lib/util/query/index.js";
import "next/router";
import * as O from "ramda";
import { useState as R, useMemo as b, useCallback as w } from "react";
import q from "../assets/background-level-header.svg.js";
import F from "../assets/background-vip-banner.jpg.js";
import G from "./LevelProgressDisplay.js";
import J from "./VipAprTable.js";
import C from "./VipLpButton.js";
import M from "../hooks/json/useFetchVipLevelsJson.js";
import { useTranslation as N } from "react-i18next";
import { jsxs as a, jsx as o } from "react/jsx-runtime";
const E = t(i)`
  background-image: url(${`"${F}"`});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  box-shadow: 0px 0px 20px 0px #00000033;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 95%;
  max-width: 1050px;
  min-height: 500px;
  overflow: hidden;
  position: relative;
`, H = t(i)`
  background: #000000cc;
  padding: 10px 28px;
  width: 100%;

  ${(e) => e.theme.breakpoints.down("res768")} {
    margin-top: 20px;
  }
`, Y = t(d)`
  color: #fff;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  margin-bottom: 10px;
  text-align: center;
`, K = t(d)`
  color: #f0c056;
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  white-space: pre-line;
`, Q = t(i)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
`, U = t(S)`
  ${(e) => e.theme.breakpoints.up("res768")} {
    height: 106px;
    min-width: 814px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    height: 60px;
    width: 100%;
    min-width: 550px;
  }
`, W = t(i)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
`, X = t(G)`
  ${(e) => e.theme.breakpoints.down("res768")} {
    width: 250px;
  }
`, Z = t(i)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`, ee = t(i)`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  width: 100%;

  ${(e) => e.theme.breakpoints.up("res768")} {
    padding: 0px 100px 0px 100px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    padding: 0px 20px 0px 20px;
  }
`, te = t(C)`
  .MuiButton-endIcon {
    right: 20px;
    position: absolute;
  }
`, oe = t(d)`
  color: #f0b80e;
  font-weight: 300;
  text-decoration: underline;
  position: relative;
  transition: transform ${D}ms;

  :hover {
    transform: translateY(-2px);
  }
`, Ee = (e) => {
  var h, g, v, k;
  const {
    className: y,
    showApr: L = !0,
    urlAdd: x,
    urlStake: B,
    onAdd: T,
    onStake: u
  } = e, [_, f] = R(!1), {
    t: n
  } = N(), {
    account: p,
    isLoggedIn: $
  } = V(), {
    config: r
  } = I(), {
    data: l
  } = M(), c = b(() => l == null ? void 0 : l.find((m) => {
    var s;
    return m.level === ((s = p.vipLevel) == null ? void 0 : s.level);
  }), [(h = p.vipLevel) == null ? void 0 : h.level, l]), A = b(() => O.map((s) => n("vip.stake.duration_bonus", {
    count: s.duration,
    ratio: s.boostRatio
  }), (r == null ? void 0 : r.vipLevel.percentage) || []).join(" , "), [r == null ? void 0 : r.vipLevel.percentage, n]), j = w((m) => {
    f(!0), m.stopPropagation();
  }, []), P = w(() => {
    f(!1);
  }, []);
  return /* @__PURE__ */ a(E, {
    className: y,
    children: [/* @__PURE__ */ a(Q, {
      children: [/* @__PURE__ */ o(U, {
        src: q
      }), /* @__PURE__ */ o(W, {
        children: $ ? /* @__PURE__ */ o(X, {
          level: ((g = p.vipLevel) == null ? void 0 : g.level) ?? 1,
          levelTitle: (c == null ? void 0 : c.title) ?? "",
          nextLevelPoint: ((v = p.vipLevel) == null ? void 0 : v.nextLevelPoint) ?? 0,
          progress: ((k = p.vipLevel) == null ? void 0 : k.progress) ?? 0,
          urlAdd: x,
          onAddClick: u
        }) : /* @__PURE__ */ o(z, {
          remark: n("login.require.vip")
        })
      })]
    }), /* @__PURE__ */ a(Z, {
      children: [/* @__PURE__ */ a(ee, {
        children: [/* @__PURE__ */ o(C, {
          href: x,
          target: "_blank",
          onClick: T,
          children: n("vip.button.get_lp_token")
        }), /* @__PURE__ */ o(te, {
          endIcon: (
            // ? this box avoid end-icon override font-size to 20px
            L ? /* @__PURE__ */ o(i, {
              children: /* @__PURE__ */ o(oe, {
                onClick: j,
                children: n("lp_token.apr_hint")
              })
            }) : null
          ),
          href: B,
          target: "_blank",
          onClick: u,
          children: n("vip.button.stake")
        })]
      }), /* @__PURE__ */ a(H, {
        children: [/* @__PURE__ */ o(Y, {
          children: n("vip.stake.info_description")
        }), /* @__PURE__ */ o(K, {
          children: n("vip.stake.orderly_point_bonus", {
            bonus: A
          })
        })]
      })]
    }), /* @__PURE__ */ o(J, {
      open: _,
      onClose: P
    })]
  });
};
export {
  Ee as VipBanner,
  Ee as default
};
//# sourceMappingURL=VipBanner.js.map
